import { render, staticRenderFns } from "./FileExample.vue?vue&type=template&id=cd164eb4&scoped=true"
import script from "./FileExample.vue?vue&type=script&lang=ts"
export * from "./FileExample.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd164eb4",
  null
  
)

export default component.exports